import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewMore: {
		id: 'compass-common.scorecards-health-lozenge.popup-content.view-more',
		defaultMessage: 'View more',
		description: 'Button shown to allow users to view more scorecards.',
	},
});
